import axios from 'axios';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Card, CardHeader } from 'reactstrap'
import Swal from 'sweetalert2';
import { configuration } from '../appConfig';
import PhotoApp from './common/photoGallery/PhotoApp'
import './picturegallery.css';

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class PictureGallery extends Component {
  state = {
    lang: "",
    words: {},
    downloadProgress: 0,
    downloading: false,
    isFullView: false,
    imageName: "",
    isdownloaddisabled:false

  };

  componentDidMount() {
    this.getLang()
    // this.downloadFolderZip()
  }
  getLang = async () => {
    const base_url = window.location.origin;
    axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  downloadFolderZip = () => {
    this.setState({
      downloading: true
    })
    let [partnerId, vin] = [localStorage.getItem('partnerId'), localStorage.getItem('selectedFile')]
    const { lang } = this.state
    let url = `${configuration.downloadExtraImage}?partnerId=${partnerId}&vin=${vin}&lang=${lang}`
    axios.get(url)
      .then((res) => {
        if (res.data.status === 200 && res.data.data.trim().length) {
          this.downloadFile(res.data.data, `${vin}_${this.lang("Images")}.zip`)
            .then(() => {
              this.setState({
                downloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "success",
                title: "Zip download successfully!",
              });
            }).catch((err) => {
              this.setState({
                downloading: false,
                downloadProgress: 0
              })
              Toast.fire({
                type: "error",
                title: "Something want wrong!",
              });
            })
        } else {
          Toast.fire({
            type: "error",
            title: "Something want wrong!",
          });
          this.setState({
            downloading: false,
            downloadProgress: 0
          })
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something want wrong!",
        });
        this.setState({
          downloading: false,
          downloadProgress: 0
        })
      })
  }

  DownloadItem = (file, fileName) => {
    const options = {
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        this.setState({
          downloadProgress: Math.floor((loaded * 100) / total),
        });
      },
    };

    axios.get(file, {
      responseType: "blob",
      ...options,
    }).then(function (response) {

      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    });

    // const formatBytes = (bytes) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }


  downloadFile = async (file, fileName) => {
    return new Promise((resolve, reject) => {
      if (file) {
        const options = {
          onDownloadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            this.setState({
              downloadProgress: Math.floor((loaded * 100) / total),
            });
          },
        };

        axios.get(file, {
          responseType: "blob",
          ...options,
        }).then(function (response) {

          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
      } else {
        reject();
      }
    })
  }

  loader = () => (
    <div>
      <div className="Loading">
        <p>Downloading... </p>
        <p>{this.state.downloadProgress} % </p>
      </div>
      <div className="progress">
        <div className="progress-bar" role="progressbar" style={{ width: `${this.state.downloadProgress}%` }} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" id="progressBar">{this.state.downloadProgress}%</div>
      </div>
    </div>
  );

  isFullView = () => {
    this.setState({
      isFullView: true 
    })
  }
  isdownloaddisabled = (disabled) => {
    this.setState({
      isdownloaddisabled: disabled 
    })
  }

  render() {
    const {isFullView} = this.state;
    const selectedFile = localStorage.getItem("selectedFile");
    const client =  localStorage.getItem("client");
    return (
      <>
        <div className="animated fadeIn swissNewFullReport">
          <div xs="12" sm="12" className="p-2">
            <Card className="print_button_card mt-2">
              <CardHeader>
                <div className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                      {(client === "SWISS" || client === "POLAND") &&
                        <>
                           <small> <span>{this.lang("DashboardVIN")} :</span> {localStorage.getItem("selectedFile")}</small>
                        </>}
                      {(client !== "SWISS" && client !== "POLAND") &&  <small> <span>{this.lang("DashboardVIN")} :</span> {localStorage.getItem("selectedFile")}</small>}
                    </div>
                    <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                        <button type="button"
                        disabled={this.state.isdownloaddisabled}
                        // className="download_image_button"
                         className={`${(this.state.isdownloaddisabled ? "download_image_button_disabled": "download_image_button")}`} 
                         onClick={() => this.downloadFolderZip()} 
                          
                        >
                          {this.state.downloading ?
                            <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                              <span className="sr-only">Loading...</span>
                            </div>
                            :
                            <i className="fa fa-download" aria-hidden="true"></i>
                          }
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
        
        <div className='container'>
        <div className='row p-0 pt-2 justify-content-center'>
          <div className={`col-xl-${isFullView ? '12' : '8' } col-lg-${isFullView ? '12' : '8'} col-md-8 col-sm-8 p-0 pt-3 parent_img' id="parent_img`}>
            <Card className={`pb-3 ${isFullView ? "photo_gallery_extraImage" : 'photo_gallery'}`}>
              <PhotoApp xl={isFullView ? '3' : "4"} lg={isFullView? '3' : "4"} md="4" sm="4" col="4" mb="1" isDashboard={false} isFullView={() => this.isFullView()} isdownloaddisabled={(disabled)=>this.isdownloaddisabled(disabled)} isShowImage={true} isOpenImage={true} showNextPrevButton={true} showOption={true} showExtraImageOPen={false}/>
              {/* <PhotoApp isShowImage={true} isOpenImage={true} showOption={false} isFullView={() => this.isFullView()}/> */}
            </Card>
          </div>

          {/* <div className='col-xl-2 col-lg-2 col-md-12 col-sm-12 pt-0 pt-lg-3 pb-3 text-center'>
          <button type="button" className="download_image_button" onClick={() => this.downloadFolderZip()}>
            {this.state.downloading ?  
              <div className="spinner-border" role="status" style={{width : "1.5rem", height : "1.5rem"}}>
                <span className="sr-only">Loading...</span>
              </div> 
            : 
              <i className="fa fa-download" aria-hidden="true" ></i>
            }
          </button>
        </div> */}
        </div>
      </div>
      </div>
        </div>
      </>
    )
  }
}

const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};

export default connect(mapStateToProps)(PictureGallery);
